// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3xuTC","itemTitle":"ClientEmergencyInfo_itemTitle__u71BP","itemText":"ClientEmergencyInfo_itemText__2iajw"};